/**
 *
 * Select
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

/* eslint-disable react/prefer-stateless-function */

import Selector, { components } from "react-select"
import { List } from "react-virtualized"
import { Avatar, Empty, Tooltip } from "antd"
import { flatMap } from "lodash"
import {
  DownOutlined,
  CloseCircleFilled,
  LoadingOutlined,
} from "@ant-design/icons"
import "./index.less"

const MenuList = (props) => {
  const rows = props.children

  const _getOptionHeight = ({ option }) => {
    const optionHeight = 32
    return optionHeight instanceof Function
      ? optionHeight({ option })
      : optionHeight
  }

  const _calculateListHeight = (options) => {
    const { maxHeight } = props
    let height = 0
    for (let optionIndex = 0; optionIndex < options.length; optionIndex++) {
      const option = options[optionIndex]
      height += _getOptionHeight({ option })
      if (height > maxHeight) {
        return maxHeight
      }
    }
    return height
  }

  const rowRenderer = ({ key, index, style }) => (
    <Tooltip
      key={key}
      title={rows[index].props.label}
      placement="leftTop"
      align={{ offset: [4, -2] }}>
      <div style={style}>{rows[index]}</div>
    </Tooltip>
  )

  const _setWidth = () => {
    let width = 300
    if (document.querySelector(`#${props.selectProps.wrapperId}`)) {
      width = document.querySelector(`#${props.selectProps.wrapperId}`)
        .offsetWidth
    }
    return width
  }

  if (rows.length === 0 || rows.length === undefined) {
    return (
      <components.NoOptionsMessage {...props}>
        <Empty
          style={{ margin: "8px 0" }}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </components.NoOptionsMessage>
    )
  }

  return (
    <List
      style={{ width: "100%", maxWidth: "auto" }}
      width={_setWidth()}
      height={_calculateListHeight(rows)}
      rowHeight={32}
      rowCount={rows.length || 0}
      rowRenderer={rowRenderer}
    />
  )
}

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <DownOutlined
      style={{
        fontSize: 12,
        marginTop: 2,
        transform: props.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      }}
    />
  </components.DropdownIndicator>
)

const ClearIndicator = (props) => {
  const {
    innerProps: { ref, ...restInnerProps },
  } = props
  return (
    <div
      {...restInnerProps}
      ref={ref}
      className="Selector-clear"
      style={{
        position: "absolute",
        right: 10,
        top: 1,
        backgroundColor: "white",
        height: 20,
        width: 14,
        cursor: "pointer",
        zIndex: 1,
      }}>
      <CloseCircleFilled
        style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.25)" }}
      />
    </div>
  )
}

const LoadingIndicator = (props) => {
  return (
    <LoadingOutlined
      style={{ fontSize: 12 }}
      spin
      style={{
        position: "absolute",
        zIndex: 1,
        background: props.selectProps.isDisabled ? "#f5f5f5" : "#FFF",
      }}
    />
  )
}

const SingleValue = ({ children, ...props }) => {
  if (props.selectProps.labelImage) {
    return (
      <components.SingleValue {...props}>
        <div>
          <Avatar src={props.data[props.selectProps.labelImage]} size={19} />
          <div
            style={{
              width: "94%",
              overflow: "hidden",
              display: "inline-block",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              verticalAlign: "bottom",
              paddingLeft: 5,
            }}>
            {children}
          </div>
        </div>
      </components.SingleValue>
    )
  }
  return (
    <components.SingleValue {...props}>
      <Tooltip
        title={children}
        placement="leftTop"
        align={{ offset: [-8, -5] }}>
        {children}
      </Tooltip>
    </components.SingleValue>
  )
}

const MultiValueRemove = (props) => {
  return <components.MultiValueRemove {...props}>×</components.MultiValueRemove>
}

class Select extends React.Component {
  id = Math.random()
    .toString(36)
    .substr(2, 9)

  renderValue = () => {
    let { multi, value, options } = this.props
    if (value === undefined || value === null) return null
    value = multi ? flatMap(value, (item) => item[this.props.labelKey]) : value
    const valueReturn = multi
      ? options.filter((o) => value.includes(o[this.props.labelKey]))
      : options.find((o) => o[this.props.labelKey] === value)
    return valueReturn
  }

  render() {
    return (
      <div id={`Select__${this.id}`} style={this.props.wrapperStyle}>
        <Selector
          menuPlacement="auto"
          isMulti={this.props.multi}
          getOptionValue={(option) => option[this.props.labelKey]}
          options={this.props.options}
          value={this.renderValue()}
          labelImage={this.props.labelImage}
          wrapperId={`Select__${this.id}`}
          wrapperStyle={this.props.style}
          id={this.props.id}
          components={{
            MenuList,
            DropdownIndicator,
            ClearIndicator,
            LoadingIndicator,
            SingleValue,
            MultiValueRemove,
          }}
          getOptionLabel={(option) => option[this.props.label]}
          placeholder={this.props.placeholder}
          isDisabled={this.props.disabled}
          isClearable={this.props.allowClear}
          closeMenuOnSelect={!this.props.multi}
          hideSelectedOptions={this.props.removeSelected}
          isLoading={this.props.isLoading}
          onChange={(e) => {
            this.props.onChange(e)
            setTimeout(() => {
              const element = document.querySelector(
                `#Select__${this.id} >div >div`
              )
              if (element) {
                element.scrollTop = element.scrollHeight
              }
            }, 100)
          }}
          styles={{
            container: (base) => ({
              ...base,
              ...this.props.style,
            }),
            menu: (base) => ({
              ...base,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
              marginTop: 4,
              boxSizing: "border-box",
              borderRadius: 4,
              overflow: "hidden",
              zIndex: 1050,
            }),
            indicatorSeparator: () => ({ display: "none" }),
            indicatorsContainer: () => ({
              padding: "0 12px",
              display: this.props.multi ? "none" : null,
              i: {
                transition: "transform 0.3s, -webkit-transform 0.3s",
                color: "rgba(0, 0, 0, 0.25)",
              },
            }),
            dropdownIndicator: (base) => ({
              ...base,
              padding: "0",
            }),
            singleValue: (base, td) => ({
              ...base,
              margin: "0 2px",
              color: "#4F4F4F",
              opacity: td.selectProps.menuIsOpen ? "0.4" : 1,
            }),
            placeholder: (base) => ({
              ...base,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              color: "#bfbfbf",
            }),
            control: (base, { isDisabled, isFocused }) => ({
              ...base,
              background: isDisabled ? "#f5f5f5" : "white",
              transition: "all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)",
              borderColor: "#d9d9d9",
              border: isFocused ? "1px solid #40a9ff" : null,
              boxShadow: isFocused ? "0 0 0 2px rgba(24, 144, 255, 0.2)" : null,
              // height: 32,
              minHeight: 32,
              maxHeight: this.props.multi ? 112 : 32,
              overflowX: this.props.multi ? "auto" : null,
              flex: this.props.multi ? "auto" : 1,
              cursor: "pointer",
              ">div:first-child": {
                padding: this.props.multi ? "1px 8px 0px" : "0 8px",
                // marginTop: "-2px",
              },
              ".Selector-clear": {
                opacity: 0,
                transition: "color 0.3s ease, opacity 0.15s ease",
                i: {
                  transition: "all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)",
                  "&:hover": { color: "rgba(0, 0, 0, 0.45)" },
                },
              },
              "&:hover": { ".Selector-clear": { opacity: 1 } },
            }),
            option: (base, { data, isDisabled, isFocused, isSelected }) => ({
              ...base,
              padding: "5px 12px",
              lineHeight: "22px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              cursor: "pointer",
              backgroundColor: "transparent",
              fontWeight: isSelected ? "600" : "normal",
              color: "rgba(0, 0, 0, 0.65)",
              transition: "background 0.3s ease",
              "&:hover": { background: "#e6f7ff" },
              ".ant-tooltip-inner": { color: "white" },
            }),
            multiValue: (base) => ({
              ...base,
              backgroundColor: "#fafafa",
              border: "1px solid #e8e8e8",
            }),
            multiValueLabel: (base) => ({
              ...base,
              fontSize: "13px",
            }),
            multiValueRemove: (base) => ({
              ...base,
              color: "rgba(0,0,0,0.45)",
              transition: "all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)",
              "&:hover": {
                backgroundColor: "transparent",
                color: "rgba(0,0,0,0.65)",
              },
            }),
          }}
        />
      </div>
    )
  }
}
Select.defaultProps = {
  maxHeight: 200,
  onChange: () => {},
  placeholder: "Seleccionar",
  options: [],
  emptyText: "No hay datos",
  allowClear: false,
  label: "value",
  labelKey: "id",
  multi: false,
  style: { width: 300 },
  isLoading: false,
  removeSelected: false,
  disabled: false,
  labelImage: null,
}
export default Select
